import {
  AgentAttendanceDetailsShiftPositionsInner,
  AgentAttendanceShortShiftPositionsInner,
} from 'modules/Monitoring/types'

import { AgentAttendanceShiftState } from '../types'

export const getShiftPositionStatus = (
  position:
    | AgentAttendanceDetailsShiftPositionsInner
    | AgentAttendanceShortShiftPositionsInner,
): AgentAttendanceShiftState => {
  const currentDate = Date.now()

  if (currentDate > position.endDate) {
    return AgentAttendanceShiftState.Past
  }
  if (currentDate < position.startDate) {
    return AgentAttendanceShiftState.Upcoming
  }

  return AgentAttendanceShiftState.Active
}
